'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtendableRecord = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyNames = require('babel-runtime/core-js/object/get-own-property-names');

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = require('immutable');

var _util = require('./util');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var INITIALIZED_TOKEN = '____isInitializedForImmutability:hqQUB1vW4XLV2EmvVZWnnNS5A'; // eslint-disable-next-line import/prefer-default-export

var ExtendableRecord = exports.ExtendableRecord = function (_Collection$Keyed) {
  (0, _inherits3.default)(ExtendableRecord, _Collection$Keyed);

  function ExtendableRecord(values) {
    (0, _classCallCheck3.default)(this, ExtendableRecord);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ExtendableRecord.__proto__ || (0, _getPrototypeOf2.default)(ExtendableRecord)).call(this));

    var InstanceClassPrototype = (0, _getPrototypeOf2.default)(_this);
    var isInitialized = Object.prototype.hasOwnProperty.call(InstanceClassPrototype, INITIALIZED_TOKEN);

    if (!isInitialized) {
      InstanceClassPrototype[INITIALIZED_TOKEN] = true;
      var defaultValues = (0, _util.getDetaultPropertiesForInstance)(_this);
      var keys = (0, _getOwnPropertyNames2.default)(defaultValues);
      keys.forEach(function (key) {
        (0, _defineProperty2.default)(InstanceClassPrototype, key, {
          get: function get() {
            return this.get(key);
          },
          set: function set(value) {
            // eslint-disable-next-line no-underscore-dangle
            if (!this.__ownerID) throw new Error('Cannot set on an immutable record.');
            this.set(key, value);
          }
        });
      });
      InstanceClassPrototype.size = keys.length;
      /* eslint-disable no-underscore-dangle */

      InstanceClassPrototype._name = InstanceClassPrototype.constructor.name;
      InstanceClassPrototype._keys = keys;
      InstanceClassPrototype._defaultValues = defaultValues;
      /* eslint-enable no-underscore-dangle */
    } // eslint-disable-next-line no-underscore-dangle, new-cap


    _this._map = (0, _immutable.Map)(values);
    return _this;
  }

  return ExtendableRecord;
}(_immutable.Collection.Keyed);

var ExtendableRecordPrototype = ExtendableRecord.prototype;
var MapPrototype = _immutable.Map.prototype;
var RecordPrototype = _immutable.Record.prototype;
var DELETE = 'delete';
ExtendableRecordPrototype.toString = RecordPrototype.toString;
ExtendableRecordPrototype.has = RecordPrototype.has;
ExtendableRecordPrototype.get = RecordPrototype.get;
ExtendableRecordPrototype.clear = RecordPrototype.clear;
ExtendableRecordPrototype.set = RecordPrototype.set;
ExtendableRecordPrototype.remove = RecordPrototype.remove;
ExtendableRecordPrototype.wasAltered = RecordPrototype.wasAltered;
/* eslint-disable no-underscore-dangle */

ExtendableRecordPrototype.__iterator = RecordPrototype.__iterator;
ExtendableRecordPrototype.__iterate = RecordPrototype.__iterate;
ExtendableRecordPrototype.__ensureOwner = RecordPrototype.__ensureOwner;
/* eslint-enable no-underscore-dangle */

ExtendableRecordPrototype[DELETE] = ExtendableRecordPrototype.remove;
ExtendableRecordPrototype.deleteIn = undefined;
ExtendableRecordPrototype.removeIn = MapPrototype.removeIn;
ExtendableRecordPrototype.merge = MapPrototype.merge;
ExtendableRecordPrototype.mergeWith = MapPrototype.mergeWith;
ExtendableRecordPrototype.mergeIn = MapPrototype.mergeIn;
ExtendableRecordPrototype.mergeDeep = MapPrototype.mergeDeep;
ExtendableRecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
ExtendableRecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
ExtendableRecordPrototype.setIn = MapPrototype.setIn;
ExtendableRecordPrototype.update = MapPrototype.update;
ExtendableRecordPrototype.updateIn = MapPrototype.updateIn;
ExtendableRecordPrototype.withMutations = MapPrototype.withMutations;
ExtendableRecordPrototype.asMutable = MapPrototype.asMutable;
ExtendableRecordPrototype.asImmutable = MapPrototype.asImmutable;